import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'back-arrow-icon',
  templateUrl: './back-arrow-icon.component.html',
  styles: [':host{display: inherit;}']
})
export class BackArrowIconComponent implements OnInit {

  @Input() arrowColor: string = '#4334EC'
  @Input() arrowWidth: string = '24px'
  @Input() arrowHeight: string = '24px'
  constructor() { }

  ngOnInit(): void {
  }

}
